import { followUrlWithTracking } from '@avantia/client-and-server-utilities';
import { getConfig } from 'config/configuration';
import { AUDIT_TYPE } from 'interfaces/auditTypes';
import { sendAuditEvent } from 'utils';
import type { HpDispatchFunction } from './actionTypes';
import { fetchResolver } from './fetchResolver';

const { websiteEndpoint, quoteJourneyWebUrl } = getConfig();

const QUESTION_SET = 'editable-renewal-journey';

export interface RedirectToQuoteJourneyProps {
  policyDetailsId: string;
  historyId: number;
  policyNumber?: string;
  callmediauser: string;
  emailAddress: string;
  postcode: string;
}

interface QuoteJourneyRedirectApiResponse {
  key: string;
}

export const redirectToQuoteJourneyAction = ({
  policyDetailsId,
  historyId,
  policyNumber,
  callmediauser,
  emailAddress,
  postcode
}: RedirectToQuoteJourneyProps) => {
  return (dispatch: HpDispatchFunction<any>): Promise<void> | void => {
    const buildUrl = (key: string): string => {
      const params = new URLSearchParams({
        policyDetailsId,
        // 0 means the quoteJourney will determine the correct historyId
        // We need to do this currently because the historyId provided to this function
        // is sometimes not the correct one for renewals (particularly when there are multiple renewal edits).
        historyId: String(0),
        source: 'tcas',
        quoteType: 'ren',
        callmediauser,
        customerDetailsKey: key
      });

      return `${quoteJourneyWebUrl}/landing?${params.toString()}`;
    };

    dispatch({ type: 'QUOTE_JOURNEY_REDIRECT_LOADING' });

    return fetchResolver<QuoteJourneyRedirectApiResponse>({
      options: {
        url: `${websiteEndpoint}/api/policy-portal-redirect`,
        method: 'POST',
        data: { policyDetailsId, historyId, questionSet: QUESTION_SET, emailAddress, postcode },
        description: 'Redirect to Quote Journey'
      },
      dispatch,
      successAction: (response) => {
        sendAuditEvent({
          activityId: AUDIT_TYPE.RENEWAL_JOURNEY_ACCESS_VALIDATION_SUCCESS,
          policyDetailsId,
          historyId,
          policyNumber
        });
        followUrlWithTracking(buildUrl(response.key), { context: { reason: 'quote-journey-redirect' } });
        dispatch({ type: 'QUOTE_JOURNEY_REDIRECT_SUCCESS' });
      },
      failedAction: () => {
        dispatch({ type: 'QUOTE_JOURNEY_REDIRECT_ERROR' });
      }
    });
  };
};
